import { expVal } from '@atlassian/jira-feature-experiments';

const BoardBulkIssueActionsEnabled = {
	get(): boolean {
		return expVal('bulk_ops_in_harmonised_board', 'isEnabled', false);
	},
};

export default BoardBulkIssueActionsEnabled;
